import { resources } from "@constants/hardcoded-strings";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { FormattedWorkflowDetailsConfiguration } from "@idw-types/data/workflow-details-configuration";
import { WorkflowGeneralBasicInfoValidationErrors, WorkflowGeneralValidationErrors } from "@idw-types/common/validation/workflow-details-validation-errors";
import { getGeneralAdvancedValidationErrors } from "../verification-service/general/general-advanced-validation-util";
import { getWorkflowGeneralTranslationValidationErrors } from "./workflow-translation-validation-util";
import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { BaseRedirectUrl } from "@idw-types/redirect-url-information";

export const getWorkflowGeneralValidationErrors = (
    workflowDetailsConfiguration: FormattedWorkflowDetailsConfiguration,
    isMultiLanguageEnabled: boolean,
    availableLanguages: Array<LocaleTypes>,
    redirectUrls: Array<BaseRedirectUrl>
): WorkflowGeneralValidationErrors => {

    const basicInfoValidationErrors = getWorkflowGeneralBasicInfoValidationErrors(workflowDetailsConfiguration, redirectUrls);
    const advancedValidationErrors = getGeneralAdvancedValidationErrors([], workflowDetailsConfiguration.appliedProfiles, [], false);

    const translationValidationErrors = getWorkflowGeneralTranslationValidationErrors(isMultiLanguageEnabled, availableLanguages)
    const count = basicInfoValidationErrors.count + advancedValidationErrors.count+ translationValidationErrors.count;

    return {
        basicInfo: basicInfoValidationErrors,
        advanced: advancedValidationErrors,
        translation: translationValidationErrors,
        count: count,
        tabTitle: <TabTitleWithErrorCount tabName={resources.pages.verificationServiceDetails.tabs.general.tabName} errorCount={count} />
    };
};


const getWorkflowGeneralBasicInfoValidationErrors = (
    workflowDetailsConfiguration: FormattedWorkflowDetailsConfiguration,
    redirectUrls: Array<BaseRedirectUrl>
): WorkflowGeneralBasicInfoValidationErrors => {
    let count = 0;

    let workflowNameError = null;
    let redirectUrlError = null;

    if (workflowDetailsConfiguration.name === "") {
        count += 1;
        workflowNameError = (
            <ErrorAlert>
                <span>The Workflow Name cannot be blank</span>
            </ErrorAlert>
        );
    }

    if (redirectUrls.length === 0) {
        count += 1;
        redirectUrlError = (
            <ErrorAlert>
                <span>You must configure at least one redirect URL for this workflow</span>
            </ErrorAlert>
        );
    }

    return {
        workflowNameError,
        redirectUrlError,
        count: count,
        tabTitle: <TabTitleWithErrorCount tabName={resources.pages.verificationServiceDetails.tabs.general.subTabs.basicInfo.tabName} errorCount={count} />
    };
};
